import { useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
import PropTypes from 'prop-types';
import Entity from '../renders/entity/Entity';

/**
 *
 * @param root0
 * @param root0.options
 * @param root0.value
 * @param root0.onChange
 * @param root0.placeholder
 * @param root0.className
 * @param root0.autoFocus
 * @param root0.namespace
 * @param root0.sortOptions
 * @param root0.selectId
 * @returns {JSX} SelectInput
 */
function SelectInput({ options, value, onChange, placeholder, className, autoFocus, namespace, sortOptions = false, selectId = 'select-filter' }) {

    // State
    const [optionsTranslated, setOptionsTranslated] = useState([]);

    // Hooks
    useEffect(() => {
        setOptionsTranslated(
            options.map(option => ({
                label: getTranslatedText(option.name, option.namespace ?? namespace),
                value: option.value
            }))
        );
    }, [options]);

    const onSelect = (e) => {
        onChange(e.value);
    };

    const styles = {
        menu: (css) => ({
            ...css,
            width: 'max-content',
            minWidth: '100%'
        }),
        menuList: (css) => ({
            ...css,
            maxHeight: '70vh'
        }),
        option: (css) => ({
            ...css,
            padding: '4px 10px'
        }),
        container: (baseStyles) => ({ ...baseStyles, width: 'max-content' }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? 'var(--primary)' : '#e5e7eb',
            boxShadow: 'none',
            '&:hover': {
                borderColor: 'var(--primary)'
            }
        })
    };

    return (
        <Select
            className={className}
            options={sortOptions ? optionsTranslated.sort((a, b) => a.label.localeCompare(b.label)) : optionsTranslated}
            onChange={onSelect}
            placeholder={placeholder}
            value={optionsTranslated.find(option => option.value === value)}
            noOptionsMessage={() => <Entity entity='select.no_options' />}
            filterOption={createFilter({
                ignoreCase: true,
                ignoreAccents: true,
                matchFrom: 'any',
                stringify: option => `${option.label}`
            })}
            styles={styles}
            autoFocus={autoFocus}
            id={selectId}
        />
    );
}

SelectInput.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.object,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    namespace: PropTypes.string,
    sortOptions: PropTypes.bool,
    selectId: PropTypes.string
};

export default SelectInput;